/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { graphql, withPrefix } from 'gatsby';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';
import { css } from 'styled-components';
import options from '../helpers/ContentFulOptions';
import FullHeightBanner from '@legacy-vfuk/core-full-height-banner';
import MainLayout from '../layouts/MainLayout';
import SWBreadcrumb from '../components/pageBuilder/Sections/SWBreadcrumb';
import SectionTitledArticles from '../components/pageBuilder/Sections/SectionTitledArticles';
import { SEO } from '../components/SEO/SEO';
import { StructuredData } from '../components/SEO/StructuredData';
import { Organization } from '../helpers/StructuredData';
import StickyArticleHeader from '../components/Articles/StickyArticleHeader';
import useSiteMetadata from '../hooks/useSiteMetadata';
import useDocumentPathname from '../hooks/useDocumentPathname';
import { addSeoHeadContent, addSeoBodyContent } from '../helpers/SeoHelpers';
import setupBreadcrumbAnalitycsTags from '../helpers/setupBreadcrumbs';
import Block from '@legacy-vfuk/core-block';
import {
  BreadcrumbWrapper,
  ContentWrapper,
  HeaderWrapper,
  bgWhite,
  bgAbbey,
  RecommendedBannerWrapper,
} from './Article.styles';
import SectionHero from '../components/pageBuilder/Sections/SectionHero';
import SectionQuickSummary from '../components/pageBuilder/Sections/SectionQuickSummary/SectionQuickSummary';
import { Heading } from '@legacy-vfuk/core-heading';
import { BannerWrapper } from './Article.styles';
import UserFeedback from '../components/Articles/UserFeedback';
import SaveArticleModal from '../components/SaveArticleModal/SaveArticleModal';
import { getImageSrcFromGatsbyImageData } from '../helpers/gatsbyImageHelper';
import SectionRedCampaignBanner from '../components/pageBuilder/Sections/SectionRedCampaignBanner';
import MoreMediaArticlesSection from '../components/Articles/MoreMediaArticlesSection';
import SolutionsSection from '../components/Articles/SolutionsSection';
import ArticleBody from '../components/Articles/ArticleBody';

const Article = ({ pageContext, data, location }) => {
  const { siteUrl } = useSiteMetadata();
  const {
    slug,
    categoryTagName,
    categorySlugName,
    articleIndex,
    homePageName,
    showArticleBanner,
    homePageUrl,
    externalPageName,
    externalPageUrl,
    allFilterableArticles,
    configArticlePages,
    recommendedArticlesContainer,
    allContentTypes,
    globalBackgroundColors,
    saveArticleModalContent,
  } = pageContext;

  const {
    name,
    customMetadata,
    scripts,
    mainImage,
    responsiveImageCollection,
    articleTitle,
    contentType,
    contentLevel,
    quickSummary,
    body,
    readingTime,
    readingTimeTooltipContent,
    seoTitle,
    gCode,
    seoDescription: { seoDescription },
    updatedAt,
    publishingDate,
    createdAt,
    recommendedArticles,
    sharingsocialMediaImage,
    backgroundColor,
    solutions = {},
  } = data.contentfulPageArticle;

  const ARTICLE_STORAGE_NAME = 'viewed-articles';

  const [breadcrumbItems, setBreadcrumbItems] = useState({
    renderItems: [],
    seoItems: [],
  });
  const [seoPageChangeReady, setSeoPageChangeReady] = useState(false);

  const [isSaveModalOpen, setIsSaveModalOpen] = useState(false);
  const [relatedArticleSlug, setRelatedArticleSlug] = useState('');

  const parsedRawArticleBody = JSON.parse(body.raw);

  const {
    contentfulPageArticle,
    contentfulSiteConfig,
    contentfulConfigArticlePages,
  } = data;
  const pathnameArray = location.pathname.split('/');
  const isSecondLanguageOnUrl = pathnameArray.includes(
    data.contentfulSiteConfig.secondLanguageUrlPrefix
  );

  const foundTopic =
    contentfulPageArticle.topics && contentfulPageArticle.topics.length > 0
      ? contentfulPageArticle.topics[0]
      : null;
  const foundSubtopic =
    contentfulPageArticle.subtopics &&
    contentfulPageArticle.subtopics.length > 0
      ? contentfulPageArticle.subtopics[0]
      : null;

  const feedBackConfig =
    configArticlePages &&
    configArticlePages.feedbackQuestionLabel &&
    configArticlePages.positiveFeedbackLabel &&
    configArticlePages.negativeFeedbackLabel &&
    configArticlePages.feedbackThanksLabel
      ? {
          feedbackQuestionLabel: configArticlePages.feedbackQuestionLabel,
          positiveFeedbackLabel: configArticlePages.positiveFeedbackLabel,
          negativeFeedbackLabel: configArticlePages.negativeFeedbackLabel,
          feedbackThanksLabel: configArticlePages.feedbackThanksLabel,
          articleSlug: slug,
        }
      : null;

  const onSaveIconClickHandler = slug => {
    setIsSaveModalOpen(true);
    if (slug) {
      setRelatedArticleSlug(slug);
    }
  };

  const onCloseModalHandler = () => {
    setIsSaveModalOpen(false);
    setRelatedArticleSlug('');
  };

  const calculateRelevance = (article, currentArticle) => {
    let relevance = 0;
    // article becomes more relevant to currentArticle the
    // more topics the two have in common.
    if (article.slug !== currentArticle.slug) {
      article.topics.forEach(articleTopic => {
        currentArticle.topics.forEach(currentArticleTopic => {
          if (
            Object.values(currentArticleTopic).includes(articleTopic.slugName)
          ) {
            relevance++;
          }
        });
      });
    } else {
      // Make the article least relevant to itself.
      relevance = -1;
    }
    return relevance;
  };

  let autoSelectedMoreMediaArticles = [];

  let autoSelectedRelevantArticles = allFilterableArticles.filter(
    article => article.slug !== slug && article.abExperiments.length === 0
  );

  if (contentType.isMedia) {
    autoSelectedMoreMediaArticles = allFilterableArticles
      .filter(
        article => article.slug !== slug && article.abExperiments.length === 0
      )
      .filter(article => article.contentType.isMedia === true);

    autoSelectedMoreMediaArticles = autoSelectedMoreMediaArticles
      .sort((a, b) => (a.updatedAt > b.updatedAt && -1) || 1)
      .sort(
        (a, b) =>
          (calculateRelevance(a, contentfulPageArticle) >
            calculateRelevance(b, contentfulPageArticle) &&
            -1) ||
          1
      )
      .slice(0, 2);

    const moreMediaSlugs = new Set(
      autoSelectedMoreMediaArticles.map(article => article.slug)
    );

    autoSelectedRelevantArticles = autoSelectedRelevantArticles
      .filter(article => article.contentType.isMedia === true)
      .filter(article => !moreMediaSlugs.has(article.slug));
  }

  autoSelectedRelevantArticles = autoSelectedRelevantArticles
    .sort((a, b) => (a.updatedAt > b.updatedAt && -1) || 1)
    .sort(
      (a, b) =>
        (calculateRelevance(a, contentfulPageArticle) >
          calculateRelevance(b, contentfulPageArticle) &&
          -1) ||
        1
    )
    .slice(0, 4);

  const autoSelectedRecommendedArticleContent = {
    __typename: 'ContentfulSectionElementArticleIndex',
    id: 'autoSelectedRecommendedArticlesId',
    carouselContainer: false,
    articles: autoSelectedRelevantArticles,
  };

  const autoSelectedRecommendedContent = contentType.isMedia
    ? [
        recommendedArticlesContainer?.mediaContent[0],
        autoSelectedRecommendedArticleContent,
        recommendedArticlesContainer?.mediaContent[1],
      ]
    : [
        recommendedArticlesContainer?.content[0],
        autoSelectedRecommendedArticleContent,
        recommendedArticlesContainer?.content[1],
      ];

  let editorSelectedRecommendedContent;
  if (recommendedArticles) {
    editorSelectedRecommendedContent = recommendedArticles[0]?.content;
  }

  // Recommended or Related articles displayed at the bottom of each article page
  const recommendedArticlesContent = () => {
    let selectedRecommendedContent =
      editorSelectedRecommendedContent || autoSelectedRecommendedContent;
    selectedRecommendedContent = selectedRecommendedContent?.map(item => {
      if (item?.__typename === 'ContentfulSectionElementCtaButtonRow') {
        item.buttons = item.buttons.map(button => {
          if (button.url === 'no-url') {
            button.url = withPrefix(`/${articleIndex.slug}`);
          }
          return button;
        });
      }
      return item;
    });

    if (selectedRecommendedContent) {
      return (
        <div>
          <SectionTitledArticles
            slug={articleIndex.slug}
            content={selectedRecommendedContent}
            seoTitle={seoTitle}
            withCarousel={selectedRecommendedContent.length > 2}
            displaySaveIcon={configArticlePages.displaySaveIcon}
            saveLabelText={configArticlePages.saveLabelText}
            saveIconClicked={onSaveIconClickHandler}
            onMediaArticle={contentType.isMedia}
            seeAllLabel={contentType.isMedia && configArticlePages.seeAllLabel}
            seeAllUrl={
              contentType.isMedia &&
              configArticlePages.seeAllLabel &&
              withPrefix(`/${articleIndex.slug}?shelf=media`)
            }
          />
        </div>
      );
    } else {
      return null;
    }
  };

  //Banner displayed at the bottom of each article page.
  const bannerSection = () => {
    const articlePageBanner = recommendedArticlesContainer.banner;

    if (articlePageBanner) {
      if (
        articlePageBanner.__typename === 'ContentfulSectionHeroWithTextAndCta'
      ) {
        return (
          <SectionHero
            name={articlePageBanner.name}
            textPosition={articlePageBanner.textPosition}
            content={articlePageBanner.content}
            mirrorContent={articlePageBanner.mirrorContent}
            responsiveImageCollection={
              articlePageBanner.responsiveImageCollection
            }
          />
        );
      } else if (
        articlePageBanner.__typename === 'ContentfulSectionRedCampaignBanner'
      ) {
        return (
          <SectionRedCampaignBanner
            key={articlePageBanner.id}
            title={articlePageBanner.title}
            bodyText={articlePageBanner.bodyText}
            linkText={articlePageBanner.linkText}
            bannerColor={articlePageBanner.bannerColor}
            targetUrl={articlePageBanner.targetUrl}
            linkType={articlePageBanner.linkType}
            scrollToId={articlePageBanner.scrollToId}
            backgroundColor={articlePageBanner.backgroundColor}
            image={articlePageBanner.image}
            label={articlePageBanner.label}
            buttonRow={articlePageBanner.buttonRow}
          />
        );
      }
    } else {
      return null;
    }
  };

  // Setting up breadcrumbs analytics
  useEffect(() => {
    setupBreadcrumbAnalitycsTags();
  }, []);

  // Remove the visually hidden h2 Element, embedded in the Breadcrumb component
  useEffect(() => {
    const elems = Array.from(document.getElementsByTagName('h2'));
    elems.forEach(elem => {
      if (elem.className === 'visually-hidden') elem.remove();
    });
  });

  let customMetaDataArray = [];
  if (customMetadata.length > 0) {
    customMetaDataArray = customMetadata.map(attributes => {
      const tag = { metadataTag: 'meta' };
      attributes.attributes.forEach(attribute => {
        tag[attribute.name] = attribute.value;
      });
      return tag;
    });
  }

  const storeArticleView = () => {
    if (typeof window !== 'undefined' && window && window.localStorage) {
      let viewedArticles = JSON.parse(
        window.localStorage.getItem(ARTICLE_STORAGE_NAME) || '[]'
      );
      viewedArticles = viewedArticles.filter(articleView => {
        return articleView !== slug;
      });
      viewedArticles.unshift(slug);
      window.localStorage.setItem(
        ARTICLE_STORAGE_NAME,
        JSON.stringify(viewedArticles)
      );
    }
  };

  // Add Article seo contentful scripts to the article header or body
  const articleSeo = { scripts, language: 'no_content' };
  const seoHead = useRef(addSeoHeadContent(articleSeo));

  const pathname = useDocumentPathname();

  useEffect(() => {
    // Function to check if `window.seoPageChange` is defined
    const checkSeoPageChangeReady = () => {
      if (window.seoPageChange) {
        setSeoPageChangeReady(true);
      } else {
        setTimeout(checkSeoPageChangeReady, 100);
      }
    };

    checkSeoPageChangeReady();

    return () => {
      setSeoPageChangeReady(false);
    };
  }, []);

  useEffect(() => {
    if (seoPageChangeReady) {
      try {
        window.seoPageChange(gCode);
      } catch (e) {
        console.error(e);
      }
    }
  }, [pathname, seoPageChangeReady, gCode]);

  useEffect(() => {
    addSeoBodyContent(articleSeo);
    storeArticleView();
  }, []);

  const SocialSharingImage = () => {
    if (sharingsocialMediaImage && sharingsocialMediaImage.gatsbyImageData) {
      return getImageSrcFromGatsbyImageData(
        sharingsocialMediaImage.gatsbyImageData
      ).split('?')[0];
    }

    return getImageSrcFromGatsbyImageData(mainImage.gatsbyImageData).split(
      '?'
    )[0];
  };

  const backgroundColorCSS = backgroundColor === 'white' ? bgWhite : bgAbbey;

  const backgroundImage = {
    sm: {
      src: getImageSrcFromGatsbyImageData(mainImage.gatsbyImageData),
    },
    md: {
      src: getImageSrcFromGatsbyImageData(mainImage.gatsbyImageData),
    },
    lg: {
      src: getImageSrcFromGatsbyImageData(mainImage.gatsbyImageData),
    },
    xl: {
      src: getImageSrcFromGatsbyImageData(mainImage.gatsbyImageData),
    },
  };

  useEffect(() => {
    setBreadcrumbItems(createBreadCrumbItems());
  }, [
    externalPageName,
    externalPageUrl,
    homePageName,
    name,
    articleIndex.name,
    articleIndex.slug,
    siteUrl,
    location.pathname,
  ]);

  const createBreadCrumbItems = () => {
    let breadCrumbPosition = 1;
    const items = { renderItems: [], seoItems: [] };

    if (externalPageName && externalPageUrl) {
      items.renderItems.push({
        id: externalPageName,
        text: externalPageName,
        href: externalPageUrl,
      });
      items.seoItems.push({
        '@type': 'ListItem',
        position: 1,
        name: externalPageName,
        item: externalPageUrl,
      });
    }

    items.renderItems.push(
      {
        id: homePageName,
        text: homePageName,
        href: withPrefix(homePageUrl),
      },
      {
        id: articleIndex.name,
        text: articleIndex.name,
        href: withPrefix(`/${articleIndex.slug}`),
      }
    );

    if (foundTopic) {
      items.renderItems.push({
        id: foundTopic.name,
        text: foundTopic.displayName,
        href: withPrefix(
          `/${articleIndex.slug}?query_topic=${foundTopic.slugName}`
        ),
      });
    }

    if (foundSubtopic) {
      items.renderItems.push({
        id: foundSubtopic.name,
        text: foundSubtopic.displayName,
        href: withPrefix(
          `/${articleIndex.slug}?query_subtopic=${foundSubtopic.slugName}`
        ),
      });
    }

    items.renderItems.push({
      id: name,
      text: name,
    });

    items.seoItems.push({
      '@type': 'ListItem',
      position: breadCrumbPosition,
      name: homePageName,
      item: `${siteUrl}${withPrefix(homePageUrl)}`,
    });

    breadCrumbPosition++;

    items.seoItems.push({
      '@type': 'ListItem',
      position: breadCrumbPosition,
      name: articleIndex?.name,
      item: `${siteUrl}${withPrefix(`/${articleIndex.slug}/`)}`,
    });

    if (foundTopic) {
      breadCrumbPosition++;
      items.seoItems.push({
        '@type': 'ListItem',
        position: breadCrumbPosition,
        name: foundTopic.displayName,
        item: `${siteUrl}${withPrefix(
          `/${articleIndex.slug}?query_topic=${foundTopic.slugName}/`
        )}`,
      });
    }

    if (foundSubtopic) {
      breadCrumbPosition++;
      items.seoItems.push({
        '@type': 'ListItem',
        position: breadCrumbPosition,
        name: foundSubtopic.displayName,
        item: `${siteUrl}${withPrefix(
          `/${articleIndex.slug}?query_subtopic=${foundSubtopic.slugName}/`
        )}`,
      });
    }

    breadCrumbPosition++;
    items.seoItems.push({
      '@type': 'ListItem',
      position: breadCrumbPosition,
      name: seoTitle,
      item: `${siteUrl}${location.pathname}`,
    });

    return items;
  };

  const renderSolutionsSection = () => {
    const hasSolutions = solutions && solutions.solutions !== null;
    const hasTagTopicSolutions =
      configArticlePages.solutionsSectionHeader && foundTopic?.solutions;

    if (!hasSolutions && !hasTagTopicSolutions) return null;

    const sectionData = hasSolutions ? solutions : foundTopic.solutions;

    return (
      <Block className="section" paddingLevel={1} css={bgWhite}>
        <SolutionsSection
          header={configArticlePages.solutionsSectionHeader}
          topicName={foundTopic?.displayName || ''}
          summary={sectionData.summary}
          solutions={sectionData.solutions}
          displaySaveIcon={configArticlePages.displaySaveIcon}
          saveLabelText={configArticlePages.saveLabelText}
          saveIconClicked={onSaveIconClickHandler}
        />
      </Block>
    );
  };

  return (
    <MainLayout locationPathname={location.pathname}>
      {saveArticleModalContent && (
        <SaveArticleModal
          header={saveArticleModalContent.header}
          bodyText={saveArticleModalContent.bodyText}
          buttonText={saveArticleModalContent.buttonText}
          buttonUrl={saveArticleModalContent.buttonUrl}
          footerText={saveArticleModalContent.footerText}
          footerLinkText={saveArticleModalContent.footerLinkText}
          footerLinkUrl={saveArticleModalContent.footerLinkUrl}
          articleSlug={relatedArticleSlug || slug}
          onArticle={true}
          isOpen={isSaveModalOpen}
          onClose={onCloseModalHandler}
        />
      )}
      {seoHead.current}
      <StructuredData>
        {{
          '@context': 'https://schema.org',
          '@type': 'BreadcrumbList',
          itemListElement: breadcrumbItems.seoItems,
        }}
      </StructuredData>
      <StructuredData>
        {{
          '@context': 'https://schema.org',
          '@type': 'Article',
          name: seoTitle,
          description: seoDescription,
          image: [
            `${
              getImageSrcFromGatsbyImageData(mainImage.gatsbyImageData).split(
                '?'
              )[0]
            }}`,
          ],
          articleBody: documentToPlainTextString(parsedRawArticleBody),
          datePublished: publishingDate || createdAt,
          dateModified: updatedAt,
          author: Organization,
          publisher: Organization,
        }}
      </StructuredData>
      <SEO
        metadata={[
          ...[
            {
              content: seoTitle,
              metadataTag: 'title',
            },
            {
              name: 'description',
              content: seoDescription,
              metadataTag: 'meta',
            },
            {
              name: 'og:type',
              content: 'article',
              metadataTag: 'meta',
            },
            {
              name: 'og:title',
              content: seoTitle,
              metadataTag: 'meta',
            },
            {
              name: 'og:description',
              content: seoDescription,
              metadataTag: 'meta',
            },
            {
              name: 'og:image',
              content: `${SocialSharingImage()}`,
              metadataTag: 'meta',
            },
            {
              name: 'twitter:title',
              content: seoTitle,
              metadataTag: 'meta',
            },
            {
              name: 'twitter:description',
              content: seoDescription,
              metadataTag: 'meta',
            },
            {
              name: 'twitter:image',
              content: `${SocialSharingImage()}`,
              metadataTag: 'meta',
            },
          ],
          ...customMetaDataArray,
        ]}
      />

      {showArticleBanner && (
        <BannerWrapper>
          <FullHeightBanner
            heading={{ text: name, level: 1 }}
            backgroundImage={backgroundImage}
            enableOverlay
          />
        </BannerWrapper>
      )}

      <BreadcrumbWrapper>
        <SWBreadcrumb
          location="article"
          items={
            breadcrumbItems.renderItems.length > 0
              ? breadcrumbItems.renderItems
              : createBreadCrumbItems().renderItems
          }
        />
      </BreadcrumbWrapper>

      <StickyArticleHeader
        contentfulConfigArticlePages={configArticlePages}
        contentfulSiteConfig={contentfulSiteConfig}
      />

      <Block
        className="article-wrapper section"
        css={css`
          display: flex;
          p:first-of-type {
            margin-top: 30px !important;
          }
          background-color: var(--${backgroundColor || 'gallery'});
        `}
      >
        <ContentWrapper>
          {!showArticleBanner && (
            <HeaderWrapper>
              <Heading size={3} level={1} text={articleTitle || name} />
            </HeaderWrapper>
          )}
          <SectionQuickSummary
            contentType={contentType}
            tagTopic={foundTopic}
            subtopics={contentfulPageArticle.subtopics}
            contentLevel={contentLevel}
            publishingDate={publishingDate || createdAt}
            readingTime={readingTime}
            readingTimeTooltipContent={readingTimeTooltipContent}
            title={quickSummary && quickSummary.title}
            displaySaveIcon={configArticlePages.displaySaveIcon}
            saveLabelText={configArticlePages.saveLabelText}
            quickSummaryItems={
              quickSummary &&
              quickSummary.quickSummaryItems &&
              quickSummary.quickSummaryItems
            }
            readingTimeMinuteLabel={configArticlePages.readingTimeMinuteLabel}
            saveIconClicked={onSaveIconClickHandler}
            hasSolutions={
              (solutions && solutions.solutions !== null) ||
              (configArticlePages.solutionsSectionHeader &&
                foundTopic?.solutions)
            }
            solutionsSectionLinkLabel={
              configArticlePages.solutionsSectionLinkLabel
            }
          />
          <ArticleBody body={body} />
        </ContentWrapper>
        {contentType.isMedia && (
          <MoreMediaArticlesSection
            articles={autoSelectedMoreMediaArticles}
            articleIndexSlug={articleIndex.slug}
            seoTitle={seoTitle}
            readingTimeMinuteLabel={configArticlePages.readingTimeMinuteLabel}
            displaySaveIcon={configArticlePages.displaySaveIcon}
            saveLabelText={configArticlePages.saveLabelText}
            moreMediaHeader={configArticlePages.moreMediaHeader}
            saveIconClicked={onSaveIconClickHandler}
          ></MoreMediaArticlesSection>
        )}
        {feedBackConfig && (
          <UserFeedback feedbackConfig={feedBackConfig}></UserFeedback>
        )}
      </Block>
      <Block className="section" paddingLevel={1} css={backgroundColorCSS}>
        <div className="spring">{recommendedArticlesContent()}</div>
        <RecommendedBannerWrapper>{bannerSection()}</RecommendedBannerWrapper>
      </Block>
      {renderSolutionsSection()}
    </MainLayout>
  );
};

export default Article;

export const query = graphql`
  query ArticleBySlug($slug: String!) {
    contentfulPageArticle(slug: { eq: $slug }) {
      seoTitle
      gCode
      seoDescription {
        seoDescription
      }
      customMetadata {
        attributes {
          name
          value
        }
      }
      backgroundColor
      scripts {
        __typename
        ... on ContentfulSeoInlineScript {
          contentful_id
          scriptLocation
          script {
            script
          }
        }
        ... on ContentfulSeoExternalScript {
          contentful_id
          scriptLocation
          runType
          src
        }
        ... on ContentfulSeoPageChangeScript {
          contentful_id
          script {
            script
          }
        }
        ... on ContentfulSeoInteractionScript {
          contentful_id
          script {
            script
          }
        }
      }
      name
      summary
      mainImage {
        gatsbyImageData(
          layout: FULL_WIDTH
          breakpoints: [1366, 1920, 2400]
          placeholder: BLURRED
          quality: 80
        )
        title
        description
      }
      responsiveImageCollection {
        imageName
        isMainImage
        maxWidth
        imageTitle {
          title
          file {
            url
          }
          description
        }
      }
      sharingsocialMediaImage {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
        title
        description
      }
      solutions {
        name
        summary {
          ... on ContentfulSectionElementRichText {
            id
            text {
              raw
            }
            color
            textAlign
          }
        }
        solutions {
          id
          name
          header
          summary {
            ... on ContentfulSectionElementRichText {
              id
              text {
                raw
              }
              color
              textAlign
            }
          }
          image {
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
            title
            description
          }
          buttonRow {
            ... on ContentfulSectionElementCtaButtonRow {
              id
              buttonRowAlignment
              buttons {
                id
                label
                url
                rank
                iconRef
                linkType
                seoEventData {
                  seoEventData
                }
                customAttributeData {
                  customAttributeData
                }
              }
            }
          }
        }
      }
      articleTitle
      contentType {
        name
        displayName
        isDefault
        isMedia
      }
      contentLevel {
        name
        displayName
        level
      }
      quickSummary {
        title
        quickSummaryItems {
          itemText
          itemTextMobile
          itemTargetId
        }
      }
      body {
        raw
        references {
          ... on ContentfulAsset {
            contentful_id
            __typename
            gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
            description
            title
            file {
              url
              contentType
              details {
                image {
                  height
                  width
                }
              }
            }
          }
        }
      }
      readingTime
      readingTimeTooltipContent {
        ... on ContentfulSectionElementRichText {
          id
          text {
            raw
          }
          color
          textAlign
        }
      }
      categoryTags {
        name
        updatedAt
      }
      topics {
        id
        name
        displayName
        slugName
        solutions {
          name
          summary {
            ... on ContentfulSectionElementRichText {
              id
              text {
                raw
              }
              color
              textAlign
            }
          }
          solutions {
            id
            name
            header
            summary {
              ... on ContentfulSectionElementRichText {
                id
                text {
                  raw
                }
                color
                textAlign
              }
            }
            image {
              gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
              title
              description
            }
            buttonRow {
              ... on ContentfulSectionElementCtaButtonRow {
                id
                buttonRowAlignment
                buttons {
                  id
                  label
                  url
                  rank
                  iconRef
                  linkType
                  seoEventData {
                    seoEventData
                  }
                  customAttributeData {
                    customAttributeData
                  }
                }
              }
            }
          }
        }
      }
      subtopics {
        id
        name
        displayName
        slugName
      }
      updatedAt
      createdAt(formatString: "DD MMM YYYY")
      publishingDate(formatString: "DD MMM YYYY")
      recommendedArticles {
        __typename
        name
        ... on ContentfulSectionElementTitledArticleIndex {
          name
          content {
            __typename
            ... on ContentfulSectionElementHeader {
              name
              headerText
              appearance
              inverse
              justify
              level
              noMargin
              weight
            }
            ... on ContentfulSectionElementCtaButtonRow {
              id
              buttonRowAlignment
              buttons {
                id
                label
                url
                rank
                iconRef
                linkType
                seoEventData {
                  seoEventData
                }
                customAttributeData {
                  customAttributeData
                }
              }
            }
            ... on ContentfulSectionElementArticleIndex {
              __typename
              id
              carouselContainer
              articles {
                ... on ContentfulPageArticle {
                  id
                  __typename
                  pageArticleName: name
                  createdAt(formatString: "DD/MM/YYYY")
                  featured
                  slug
                  summary
                  contentType {
                    name
                    displayName
                    isDefault
                    isMedia
                  }
                  mainImage {
                    gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
                    title
                    description
                  }
                  articleThumbnailImage {
                    title
                    image {
                      title
                      description
                      gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
                      file {
                        details {
                          image {
                            height
                            width
                          }
                        }
                      }
                    }
                    focalPoint {
                      focalPoint {
                        x
                        y
                      }
                    }
                  }
                  body {
                    raw
                  }
                  categoryTags {
                    id
                    name
                  }
                  topics {
                    id
                    name
                    displayName
                    slugName
                  }
                  subtopics {
                    id
                    name
                    displayName
                    slugName
                  }
                }
                ... on ContentfulSectionElementVideoArticle {
                  id
                  __typename
                  name
                  slug
                  videoSummary {
                    raw
                  }
                  categoryTags {
                    id
                    name
                  }
                  topicTags {
                    id
                    name
                  }
                }
                ... on ContentfulSectionElementCard {
                  id
                  __typename
                  name
                  mainImage {
                    title
                    description
                    gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
                  }
                  cardSummary {
                    raw
                  }
                }
              }
            }
          }
        }
      }
    }
    contentfulSiteConfig {
      sharingsocialMediaButtons
      sharingsocialMediaButtonRowLabel
      secondLangSharingsocialMediaButtonRowLabel
      secondLanguageUrlPrefix
      areSocialMediaButtonsAtTop
    }
  }
`;
